import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, signal, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LoadingService } from '../../services/loading.service';
import { UserService, UserProfile } from '../../services/user.service';
import { LanguageService } from '../../services/language.service';
import { ButtonCountry } from '../../button-country/button-country.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'user-details',
  standalone: true,
  imports: [CommonModule, MatIconModule, ButtonCountry, TranslateModule],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetails implements OnInit {
  readonly panelOpenState = signal(false);
  idiomaAberto = false;
  @Output() logoutClicked = new EventEmitter<void>();
  
  private userService = inject(UserService);
  private translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private cdr = inject(ChangeDetectorRef);
  userProfile: UserProfile | null = null;

  constructor(
    private readonly router: Router, 
    private readonly authService: AuthService,
    private readonly loadingService: LoadingService
  ) {
    this.translate.addLangs(['pt', 'en', 'es']);
    this.translate.setFallbackLang('en');
    this.translate.use(this.languageService.currentLang);
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.panelOpenState.set(!this.panelOpenState());
    this.idiomaAberto = false;
  
    // Fecha o dropdown do cliente se estiver aberto
    document.dispatchEvent(new CustomEvent('fecharDropdownCliente'));
  }

  ngOnInit(): void {
    document.addEventListener('fecharDropdownUsuario', () => {
      this.panelOpenState.set(false);
      this.idiomaAberto = false;
    });
    
    // Carrega o perfil se ainda não estiver carregado
    if (!this.userService.currentProfile) {
      this.userService.loadUserProfile();
    }
    
    // Inscreve no BehaviorSubject para receber atualizações do perfil
    this.userService.userProfile$.subscribe((profile) => {
      this.userProfile = profile;
      this.cdr.markForCheck();
    });
  }
  
  toggleIdioma(event: MouseEvent): void {
    event.stopPropagation();
    this.idiomaAberto = !this.idiomaAberto;
  }

  changeLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
    this.translate.use(lang);
    this.idiomaAberto = false;
  }

  // Método para fechar o submenu quando o idioma for selecionado via button-country
  onLanguageChange(): void {
    this.idiomaAberto = false;
  }

  navigateToPage(): void {
    this.loadingService.show(this.translate.instant('header.loadingUserProfile'));
    this.router.navigate(['/user_preferences']);
  }

  @HostListener('document:click')
  fecharDropdown(): void {
    this.panelOpenState.set(false);
    this.idiomaAberto = false;
  }

  onLogout() {
    this.logoutClicked.emit();
    // Alternativamente, pode-se chamar diretamente:
    // this.authService.logout();
  }

  onLanguageChanged(_language: string): void {
    // Apenas fecha o submenu; o ButtonCountry já persiste e aplica o idioma.
    this.idiomaAberto = false;
  }

  userName(): string {
    // Retorna o nome do usuário do perfil carregado
    return this.userProfile?.nome || 'Nome do Usuário';
  }
}
